import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from './AnimatedCategoryCard.styles';

function AnimatedCategoryCard({ to, image, alt, delay = 0 }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  return (
    <S.Card
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.5, 
        delay,
        ease: 'easeOut'
      }}
      whileHover={{ 
        scale: 1.05, 
        y: -5,
        boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
        transition: { duration: 0.3 }
      }}
      whileTap={{ 
        scale: 1.02, 
        y: -2,
        transition: { duration: 0.1 }
      }}
      onClick={handleClick}
    >
      <S.CategoryImage src={image} alt={alt} />
    </S.Card>
  );
}

export default AnimatedCategoryCard;
